import request from '@/utils/request';

//新建模板消息
export function handleAddTempMsg(values) {
  return request('/mms/addTempMsg', {
    method: 'POST',
    data: values,
  });
}

//更新模板消息
export function handleUpdateTempMsg(values) {
  return request('/mms/updateTempMsg', {
    method: 'POST',
    data: values,
  });
}

//查询短信签名列表
export function getSignatureList(values) {
  return request('/sms/querySignatureList', {
    method: 'POST',
    data: values,
  });
}

//短信预览
export function postPreview(values) {
  return request('/mms/preview', {
    method: 'POST',
    data: values,
  });
}
//彩信详情
export function getTempMsgDetail(values) {
  return request('/mms/queryTempMsgDetail', {
    method: 'POST',
    data: values,
  });
}

//彩信变量
export function getTempMsgVariableList() {
  return request('/sms/queryTempMsgVariableList', {
    method: 'GET'});
}
